module.exports = __webpack_public_path__ + "img/f2cc453.png";